<template>
    <div class="wrap flex-c">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="winw < 600 ? '70px' : '100px'" class="reg-box">
            <el-form-item prop="head" class="tx-box">
                <el-upload class="avatar-uploader" :multiple="false" :auto-upload="false" action="/test" :show-file-list="false" :on-change="getAvatar">
                    <img v-if="ruleForm.head" :src="head" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="邀请码" prop="send_code" required>
                <el-input placeholder="请填写邀请码" v-model="ruleForm.send_code"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input placeholder="请输入手机号" v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input placeholder="请输入密码,不少于6位" v-model="ruleForm.password" show-password></el-input>
            </el-form-item>
            <el-form-item label="短信" prop="code">
                <div class="flex">
                    <el-input style="flex:1" v-model="ruleForm.code" placeholder="请输入验证码"></el-input>
                    <sCode :phone="ruleForm.phone" @getCode="getCode"></sCode>
                </div>
            </el-form-item>
            <el-form-item label="昵称" prop="name">
                <el-input placeholder="请输入昵称" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="生日" prop="birthday">
                <el-col :span="11">
                    <el-form-item>
                        <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.birthday" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item label="性别" prop="sex" required>
                <el-radio-group v-model="ruleForm.sex">
                    <el-radio label="男"></el-radio>
                    <el-radio label="女"></el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item style="text-align: center;">
                <el-button round class="app-btn" @click="submitForm('ruleForm')">注册</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import sCode from "@components/common/code";
    import {
        mapGetters,
        mapMutations
    } from "vuex";
    export default {
        components: {
            sCode,
        },
        data() {
            return {
                head: "",
                yq: "",
                ruleForm: {
                    head: "",
                    name: "",
                    phone: "",
                    password: "",
                    code: "",
                    birthday: "",
                    sex: "男",
                    send_code: "",
                },
                rules: {
                    name: [{
                        required: true,
                        message: "请输入昵称",
                        trigger: "blur"
                    }],
                    phone: [{
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    }],
                    password: [{
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    }],
                    code: [{
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }],
                    birthday: [{
                        required: true,
                        message: "请选择生日",
                        trigger: "blur"
                    }],
                    send_code: [{
                        required: true,
                        message: "请输入邀请码",
                        trigger: "blur"
                    }],
                },
                winw: 0,
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
            this.winw = window.innerWidth;
            this.setMeta("注册", 1);
        },
        mounted() {
            // 在组件被挂载之后调用。
        },
        methods: {
            ...mapMutations(["s_setUser"]),
            // 未获取验证码
            getCode(c) {
                this.$y_msg("请填写手机号", "error");
            },
            submitForm(formName) {
                let _this = this;
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let data = this.ruleForm;

                        data.device_id = this.$y_device(data.phone);
                        this.$y_loading();

                        setTimeout(() => {
                            _this.$y_loadingClose();
                            _this.$y_msg('邀请码有误', "error");
                        }, 1500)
                    }
                });
            },
            getAvatar(res) {
                this.head = window.URL.createObjectURL(res.raw);
                this.ruleForm.head = res.raw;
            },
        },
        computed: {
            // 计算属性
        },
        watch: {
            // 监听
        },
    };
</script>

<style lang="less" scoped>
    .reg-box {
        width: 50%;
        padding-top: 50px;

        .tx-box {
            text-align: center;

            .tx {
                width: 100px;
                height: 100px;
            }
        }

        .code-box {
            display: flex;
            align-items: center;
        }

        .app-btn {
            background: #cd7dfe;
            border: 0;
            color: #fff;
            margin-top: 30px;
            width: 200px;
            padding: 18px;
            border-radius: 30px;
        }
    }

    .avatar-uploader {
        /deep/.el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;

            &:hover {
                border-color: #cd7dfe;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 178px;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
                object-fit: cover;
            }
        }
    }

    /deep/.el-image__inner {
        width: 100px;
        height: 100px;
    }

    /* 移动端 */
    @media (max-width: 600px) {
        .reg-box {
            width: 90%;
        }
    }
</style>